import { type MenuItem, ProfileMenuGroup } from 'shared/types'

import { Heimdall } from '~/domains/platform/core/heimdall'

import analitica from './analitica'

export const stoneAccountProfileMenu = (): MenuItem[] => {
  return [
    {
      order: 1,
      label: 'Dados cadastrais',
      icon: 'person',
      show: true,
      onClick: () => {
        analitica.events.profileMenu.click('dados cadastrais')
      },
      path: '/dados-cadastrais',
      active: (route: string) => ['/stone-account/registration-data', '/dados-cadastrais'].includes(route),
      group: ProfileMenuGroup.ACCOUNT_SETTINGS
    },
    {
      order: 4,
      label: 'Segurança',
      icon: 'lock-close',
      show: true,
      onClick: () => {
        analitica.events.profileMenu.click('seguranca')
      },
      path: '/seguranca',
      active: (route: string) => ['/stone-account/auth/security', '/seguranca'].includes(route),
      group: ProfileMenuGroup.ACCESS_SECURITY
    },
    {
      order: 8,
      label: 'Aplicativos conectados',
      icon: 'device-phone',
      show: Heimdall.pass(['wip_dispute']),
      onClick: () => {
        analitica.events.profileMenu.click('aplicativos conectados')
      },
      path: '/aplicativos-conectados',
      active: (route: string) => ['/stone-account/connected-apps', '/aplicativos-conectados'].includes(route),
      group: ProfileMenuGroup.ACCESS_SECURITY
    }
  ]
}
